import { WIDGET_CONTROL_TYPE } from '@examdojo/core/widget';
import type { GraphpadWidgetConfig } from '../graphpad.model';

/**
 * Preset for testing general rational functions.
 * Focus: (ax+b)/(cx+d) with asymptote visualization.
 */
export const RATIONAL_GENERAL_PRESET: GraphpadWidgetConfig = {
  id: 'rational-general',
  type: 'graphpad',
  params: {
    f: {
      type: 'rational-general',
      params: { a: 1, b: 0, c: 1, d: -1 },
    },
    'f-asymptotes': {
      type: 'asymptotes',
      params: { of: 'f' },
    },
    'f-roots': {
      type: 'roots',
      params: { of: 'f' },
    },
  },
  display: {
    canvas: { color: 'neutral-0' },
    coordinateSystem: {
      boundingbox: { xStart: -10, xEnd: 10, yStart: -10, yEnd: 10 },
      grid: { type: 'lines', visible: false },
    },
    elements: {
      f: { curve: { color: 'indigo', strokeWidth: 3 } },
      'f-roots': {
        point: { label: { contentVariant: 'name+coord', position: 'topLeft' } },
      },
    },
  },
  behavior: {
    controls: [
      {
        id: 'slider-a',
        type: WIDGET_CONTROL_TYPE.Slider,
        label: 'a (numerator slope)',
        param: 'f.a',
        range: [-5, 5, 0.1],
        defaultValue: 1,
        editable: true,
        color: 'purple',
      },
      {
        id: 'slider-b',
        type: WIDGET_CONTROL_TYPE.Slider,
        label: 'b (numerator constant)',
        param: 'f.b',
        range: [-10, 10, 0.5],
        defaultValue: 0,
        editable: true,
        color: 'indigo',
      },
      {
        id: 'slider-c',
        type: WIDGET_CONTROL_TYPE.Slider,
        label: 'c (denominator slope)',
        param: 'f.c',
        range: [-5, 5, 0.1],
        defaultValue: 1,
        editable: true,
        color: 'green',
      },
      {
        id: 'slider-d',
        type: WIDGET_CONTROL_TYPE.Slider,
        label: 'd (denominator constant)',
        param: 'f.d',
        range: [-10, 10, 0.5],
        defaultValue: -1,
        editable: true,
        color: 'amber',
      },
    ],
  },
};
